import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-chat-message-list-unordered',
  templateUrl: './chat-message-list-unordered.component.html',
  styleUrls: ['./chat-message-list-unordered.component.scss']
})
export class ChatMessageListUnorderedComponent implements OnInit {

  @Input() index: number;
  @Input() elements: any;

  constructor() { }

  ngOnInit() {
  }

}
